export const UnitsView = {
	'Course of': 'Course of {{course}}',
	'Not reach the grade needed':
		'Have not reached the grade needed to pass the course, you can contact our support team to review your situation.',
};
